import { parseAsString, useQueryState } from "nuqs";

export function useCodemodAiPanel() {
  return useQueryState("ai_thread_id", parseAsString);
}
